import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import AddCircle from '@material-ui/icons/AddCircle';
import{ NODE_TYPE_COMPONENT,NODE_TYPE_DELIVERABLE,NODE_TYPE_WORKPACKAGE } from '../common/redux/constantes';

const styles = {
  avatar: {
  },
};

class NodeTypeSelection extends Component {
  handleClose = () => {
    this.props.onClose(null);
  };

  handleListItemClick = nodeType => {
    this.props.onClose(nodeType);
  };

  render() {
    const { classes, onClose, selectedValue, ...other } = this.props;
    return (
      <Dialog onClose={this.handleClose} aria-labelledby="simple-dialog-title" {...other}>
        <DialogTitle id="simple-dialog-title">Select the type:</DialogTitle>
        <div>
          <List>
              <ListItem button onClick={() => this.handleListItemClick(NODE_TYPE_COMPONENT)} key={"Work Component"}>
                  <AddCircle style={{color:"#616161"}}>
                  </AddCircle>
                <ListItemText primary={"Work Component"} />
              </ListItem>
              <ListItem button onClick={() => this.handleListItemClick(NODE_TYPE_DELIVERABLE)} key={"Deliverable"}>
                
                  <AddCircle style={{color:"#000"}}>
                  </AddCircle>
                
                <ListItemText primary={"Deliverable"} />
              </ListItem>
              <ListItem button onClick={() => this.handleListItemClick(NODE_TYPE_WORKPACKAGE)} key={"Work Package"}>
                
                  <AddCircle style={{color:"#00ACC1"}}>
                  </AddCircle>
                
                <ListItemText primary={"Work Package"} />
              </ListItem>
              <ListItem button onClick={() => this.handleClose()} key={"Cancel"}>
                  <CancelIcon style={{color:"#F44336"}}/>
                <ListItemText primary={"Cancel"} />
              </ListItem>
          </List>
        </div>
      </Dialog>
    );
  }
}

NodeTypeSelection.propTypes = {
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func,
  selectedValue: PropTypes.string,
};

export default withStyles(styles)(NodeTypeSelection);



// WEBPACK FOOTER //
// ./src/features/wbs/NodeTypeSelection.js